export default __webpack_public_path__ + "static/media/blog-kids-studying.52331a94.webp";